import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00a51506"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-stores__body" }
const _hoisted_2 = { class: "uf-stores__info" }
const _hoisted_3 = { class: "uf-approval__item" }
const _hoisted_4 = {
  key: 0,
  class: "uf-approval__item-avatar"
}
const _hoisted_5 = { class: "uf-approval__item-content" }
const _hoisted_6 = { class: "uf-approval__item-title" }
const _hoisted_7 = { class: "uf-approval__item-more" }
const _hoisted_8 = { class: "uf-approval__item-state" }
const _hoisted_9 = {
  key: 0,
  class: "uf-approval__arrow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: _ctx.innerShow,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.innerShow) = $event)),
    position: "right",
    style: { height: '100%', width: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_nav_bar, {
          title: "审核人",
          "left-text": "返回",
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.innerShow = false))
        }),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_3, [
                (!item.head_pic)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.name[0]), 1))
                  : (_openBlock(), _createBlock(_component_van_image, {
                      key: 1,
                      round: "",
                      fit: "cover",
                      width: "40",
                      height: "40",
                      src: item.head_pic
                    }, null, 8, ["src"])),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.department_name) + "-" + _toDisplayString(item.duty_name), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("i", {
                    class: _normalizeClass({ active: item._state === 2 })
                  }, _toDisplayString(["已通过", "审核中", ""][item._state - 1]), 3)
                ])
              ]),
              (index != _ctx.list.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_van_icon, {
                      name: "down",
                      color: "#999"
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}